document.addEventListener('DOMContentLoaded', function(){
  const headerSection = document.querySelector('.header-section');
  const headerContainer = document.querySelector('.site-header__element--top');
  let headerHeight;

  // headerHeightを更新
  function updateHeaderHeight() {
    const isHeaderSticky = getComputedStyle(headerSection).position === 'sticky';
    console.log('isHeaderSticky is' + isHeaderSticky);
    headerHeight = isHeaderSticky ? headerContainer.offsetHeight : 0;
    console.log('headerHeight is' + headerHeight);
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('resize', handleMediaQuery);

  const mql = window.matchMedia('(max-width: 768px)');

  function handleMediaQuery(mql) {
    updateHeaderHeight();

    if (mql.matches) {
      const scrollWrappers = document.querySelectorAll('.brand-top__scroll-wrapper');
      const scrollImages = document.querySelectorAll('.brand-top__image-wrapper--sp img');
      const scrollTexts = document.querySelectorAll('.brand-top__scroll-container--sp .brand-top__text-wrapper');
      brandTopScrollSp(headerHeight, scrollWrappers, scrollImages, scrollTexts);
    } else {
      brandTopScrollPC(headerHeight);
    }
  }

  updateHeaderHeight();
  handleMediaQuery(mql);

  // メディアクエリの変更時にhandleMediaQueryを実行
  mql.addListener(handleMediaQuery);

  // リサイズ時にheaderHeightを更新し、handleMediaQueryを再度実行
  window.addEventListener('resize', function() {
    updateHeaderHeight();
    handleMediaQuery(mql);
  });

  function brandTopScrollPC(headerHeight) {
    const scrollContainers = document.querySelectorAll('.brand-top__scroll-container--pc');
    scrollContainers.forEach((scrollContainer) => {
      const pinWrapper = scrollContainer.querySelector('.brand-top__pin-wrapper');
      const imageWrappers = scrollContainer.querySelectorAll('.brand-top__image-wrapper--pc');
      const textWrappers = scrollContainer.querySelectorAll('.brand-top__text-wrapper');

      const windowHeight = window.innerHeight;
      const animationDuration = window.innerHeight; // アニメーションに必要なスクロール量
      let totalScrollHeight = 0;

      // スクロール位置の計算
      const sectionPositions = [];
      imageWrappers.forEach((imageWrapper, index) => {
        const animationStart = totalScrollHeight - imageWrapper.offsetHeight;

        if (index === 0) {
          // 1枚目のセクションはアニメーションなしで常に表示
          sectionPositions.push({
            animationStart: totalScrollHeight,
            animationEnd: totalScrollHeight, // アニメーションなし
          });
          totalScrollHeight += imageWrapper.offsetHeight; // 1枚目の高さを追加
        } else {
          const animationEnd = animationStart + animationDuration;
          sectionPositions.push({
            animationStart,
            animationEnd,
          });
          totalScrollHeight += imageWrapper.offsetHeight + 600; // アニメーション終了後にマージンを追加
        }
      });

      // scroll-container の高さを設定
      scrollContainer.style.height = `${totalScrollHeight - headerHeight}px`;
      pinWrapper.style.height = `calc(100vh - ${headerHeight}px)`; // ヘッダーの高さ分だけpinWrapperの高さを調整

      window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;
        const containerTop = scrollContainer.offsetTop;

        // 固定解除を防ぎ、スティッキーヘッダーの下辺に要素が接触したらpinWrapperを固定
        if (scrollY >= containerTop - headerHeight && scrollY < containerTop + totalScrollHeight - animationDuration - headerHeight) {
          pinWrapper.classList.add('fixed');
          pinWrapper.style.top = `${headerHeight}px`; // ヘッダーの高さ分だけトップ位置を調整
        } else {
          scrollContainer.style.paddingTop = '0';
          pinWrapper.classList.remove('fixed');
          pinWrapper.style.top = '0'; // 固定解除時にtopをリセット
        }

        // 各画像とテキストの切り替え処理
        imageWrappers.forEach((imageWrapper, index) => {
          const textWrapper = textWrappers[index];
          const image = imageWrapper.querySelector('img');
          const { animationStart, animationEnd } = sectionPositions[index];

          if (index === 0) {
            // 1枚目は常に表示（アニメーションなし）
            return;
          }

          // スクロール位置に基づく進捗率を計算
          const scrollRelative = scrollY - containerTop + headerHeight;
          let progress = (scrollRelative - animationStart) / animationDuration;
          progress = Math.min(Math.max(progress, 0), 1); // 0から1の範囲にクランプ

          // アニメーション中にpinWrapperを固定
          if (progress > 0 && progress <= 1) {
            pinWrapper.classList.add('fixed');
            const wrapperTranslateY = (1 - progress) * 100;
            const imageTranslateY = (1 - progress) * 200;
            imageWrapper.style.transform = `translateY(${wrapperTranslateY}%)`;
            image.style.transform = `translateY(${-imageTranslateY}px)`;

            // テキストの切り替え
            if (progress >= 0.7 && progress <= 0.71) {
              const textProgress = (progress - 0.7) / 0.1;
              if (textWrappers[index - 1]) {
                textWrappers[index - 1].style.opacity = 1 - textProgress;
                textWrappers[index - 1].style.zIndex = textProgress < 0.5 ? 1 : 0;
              }
              textWrapper.style.opacity = 0;
              textWrapper.style.zIndex = textProgress > 0.5 ? 1 : 0;
            } else if (progress > 0.71) {
              const textProgress = (progress - 0.71) / 0.2;
              textWrapper.style.opacity = Math.min(textProgress, 1);
              textWrapper.style.zIndex = 1;
              if (textWrappers[index - 1]) {
                textWrappers[index - 1].style.opacity = 0;
                textWrappers[index - 1].style.zIndex = 0;
              }
            } else {
              textWrapper.style.opacity = 0;
              textWrapper.style.zIndex = 0;
              if (textWrappers[index - 1]) {
                textWrappers[index - 1].style.opacity = 1;
                textWrappers[index - 1].style.zIndex = 1;
              }
            }
          } else if (progress === 0) {
            imageWrapper.style.transform = `translateY(100%)`;
          } else if (progress === 1) {
            imageWrapper.style.transform = 'translateY(0)';
          }

          // 最後の画像で固定解除
          if (scrollRelative >= animationEnd + 600 && index === imageWrappers.length - 1) {
            pinWrapper.classList.remove('fixed');
            const pinMargin = imageWrappers.length - 1;
            scrollContainer.style.paddingTop = `${imageWrapper.offsetHeight * pinMargin + 600 * pinMargin}px`;
          }
        });
      });
    });
  }

  function brandTopScrollSp(headerHeight, wrappers, images, texts) {
    // スクロールイベントのリスナーを追加
    window.addEventListener('scroll', () => {
      wrappers.forEach((wrapper, index) => {
        const wrapperRect = wrapper.getBoundingClientRect();

        // 要素がビューポートに入っているか確認
        if (wrapperRect.top < window.innerHeight && wrapperRect.bottom > 0) {
          // スクロール位置の進捗率を計算
          // スティッキーヘッダーの下辺に要素の上辺が触れるタイミングで progress が 1 になる
          const targetPosition = headerHeight; // ヘッダーの下辺
          const progress = 1 - Math.min(Math.max((wrapperRect.top - targetPosition) / window.innerHeight, 0), 1);

          // 進捗に基づいて変化を計算
          let imageScale = 0.7 + progress * 0.3; // 0.7〜1に変化
          let imageRadius = 15 - progress * 15; // 15〜0に変化
          let imageOpacity = 0.5 + progress * 0.5; // 0.5〜1に変化
          let textOpacity = progress * 1; // 0〜1に変化

          // 画像にスタイルを適用
          const image = images[index];
          image.style.transform = `scale(${imageScale})`;
          image.style.borderRadius = `${imageRadius}px`;
          image.style.opacity = `${imageOpacity}`;

          // テキストにスタイルを適用
          const text = texts[index];
          text.style.opacity = `${textOpacity}`;
          text.style.zIndex = `${index}`;
        }
      });
    });
  }
});